import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, CreateCorrectionLetterPayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'CREATE_CORRECTION_LETTER_',
  }
);

export interface CreateCorrectionLetterState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface CreateCorrectionLetterRequestAction {
  payload: CreateCorrectionLetterPayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: CreateCorrectionLetterState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: CreateCorrectionLetterState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: CreateCorrectionLetterState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: CreateCorrectionLetterState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: CreateCorrectionLetterState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const createCorrectionLetter = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const CreateCorrectionLetterTypes = Types;
export const CreateCorrectionLetterActions = Creators;
